export const lazy = (component: any) =>
  defineAsyncComponent({
    loader: component,
    timeout: 4000,
    loadingComponent: () => null,
  })
